import React from 'react';
import { QdsStandaloneLink } from '@quartzds/core-react';

type Props = {
    className?: string;
    to: string;
    separateTab: boolean;
    chartLabel: string;
    openPopup?: boolean;
    clickHandlerCallback?: (url: string) => void;
};

const onClickHandler = (e: React.MouseEvent<HTMLQdsStandaloneLinkElement, MouseEvent>, url: string, clickHandlerCallback? : (url: string) => void) => {
  openPopupCenter(e, url);
  clickHandlerCallback && clickHandlerCallback(url);
}

const openPopupCenter = (e: React.MouseEvent<HTMLQdsStandaloneLinkElement, MouseEvent>, url: string, title = '', w = 1015, h = 680) => {
  e.preventDefault();
   // Fixes dual-screen position                             Most browsers      Firefox
   const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
   const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

   const width = window.innerWidth
     ? window.innerWidth
     : document.documentElement.clientWidth

   const height = window.innerHeight
     ? window.innerHeight
     : document.documentElement.clientHeight

   const systemZoom = width / window.screen.availWidth;
   const left = (width - w) / 2 / systemZoom + dualScreenLeft;
   const top = (height - h) / 2 / systemZoom + dualScreenTop;
   const newWindow = window.open(
     url,
     title,
     `
       scrollbars=yes,
       width=${w / systemZoom},
       height=${h / systemZoom},
       top=${top},
       left=${left}
       `,
   );
  
   if (window.focus) newWindow.focus();
}

export const Link: React.FC<Props> = ({ to, children, className, separateTab, chartLabel, openPopup, clickHandlerCallback }) => {
    const enhancedProps = separateTab ? { target: '_blank', rel: 'noopener noreferrer' } : {};

    if (openPopup) {
        const url = to;
        return (
            <QdsStandaloneLink 
              size='small' 
              importance='standard'
              href='/#'
              className={className}
              onClick={(e) => onClickHandler(e, url, clickHandlerCallback)}
              data-item-name={chartLabel}
              iconName={chartLabel? 'arrow-top-right-on-square': ''}
            >
              {children}
            </QdsStandaloneLink>
        )
    }

    return (
      <QdsStandaloneLink
        size='small' 
        importance='standard'
        href={to}
        className={className}
        {...enhancedProps}
        data-item-name={chartLabel}
        target='_blank'
        onClick={() => clickHandlerCallback(to)}
        iconName={chartLabel? 'arrow-top-right-on-square': ''}
      >
        {children}
      </QdsStandaloneLink>
    );
};
